module.exports = __webpack_public_path__ + "static/img/0.b4743bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/0.jpg
// module id = ihte
// module chunks = 1